import React from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import { s3_url } from "common/constants";
import LumenButton from "../../ui/LumenButton";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import "./NewLessonsPage.css";

const NewLessonsPage: React.FC = () => {
  return (
    <>
      <LumenNavbar />
      <div className="lessons lessons-page">
        <section className="lessons-hero">
          <Carousel interval={7000} indicators controls fade>
            {[1, 2, 3].map((n) => (
              <Carousel.Item key={n}>
                <div
                  className="hero-slide"
                  style={{ backgroundImage: `url(${s3_url}/poduke/${n}.webp)` }}
                >
                  <div className="hero-overlay" />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </section>

        <section className="lessons-post-hero">
          <Container>
            <div className="post-hero-text">
              <h1 className="title-shadow red-title lessons-mobile-title d-md-none">
                PODUKE
              </h1>
              <p>
                Učenje ne mora biti teško ni dosadno. Na platformi Lumen at home
                učenici mogu savladati gradivo iz hrvatskog jezika, matematike,
                fizike, kemije, biologije i stranih jezika uz stručnu podršku i
                jasno vođene lekcije. Sve se odvija u opuštenoj atmosferi
                vlastitog doma uz ritam koji odgovara svakom učeniku. Poduke su
                osmišljene kako bi potaknule razumijevanje, samopouzdanje i
                ljubav prema učenju.
              </p>

              <div className="text-center mt-3">
                <LumenButton to="/poduke/rezervacija" className="post-hero-cta">
                  PRIJAVI SE
                </LumenButton>
              </div>

              <div className="lessons-video-guide mt-5">
                <h2 className="text-center mb-4">
                  Video vodič za rezervaciju poduka
                </h2>
                <div className="video-frame">
                  <div className="responsive-video">
                    <iframe
                      src="https://www.youtube-nocookie.com/embed/BT6O-SCoU2o?rel=0&modestbranding=1&controls=1"
                      title="Video vodič za rezervaciju instrukcija"
                      loading="lazy"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      referrerPolicy="strict-origin-when-cross-origin"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>

        <section className="lessons-gallery-tempo">
          <div className="three-gallery">
            <img
              src={`${s3_url}/poduke/4.webp`}
              alt="Poduke - 1"
              loading="lazy"
            />
            <img
              src={`${s3_url}/poduke/5.webp`}
              alt="Poduke - 2"
              loading="lazy"
            />
            <img
              src={`${s3_url}/poduke/6.webp`}
              alt="Poduke - 3"
              loading="lazy"
            />
          </div>

          <div className="tempo-band">
            <Container>
              <h1 className="title-shadow text-center tempo-title my-5">
                TVOJ TEMPO, TVOJ STIL, TVOJE RAZUMIJEVANJE
              </h1>
              <p className="tempo-lead text-center my-5">
                U svakom razredu javljaju se pitanja, nesigurnosti i praznine u
                znanju. Kroz Lumen at home poduke učenici dobivaju priliku da ih
                odmah riješe uz podršku iskusnih mentora koji se prilagođavaju
                njihovom tempu i stilu učenja.
              </p>
            </Container>
          </div>
        </section>

        <section className="lessons-circles">
          <Container>
            <div className="circles-wrap">
              <div className="circle-outline">
                <div className="circle-white">
                  <div className="circle-inner">
                    <p>
                      Za razliku od kratkoročnih priprema, ove poduke
                      namijenjene su redovnom učenju i savladavanju školskog
                      gradiva tijekom cijele godine. Bilo da trebaš pomoć oko
                      zadaće, objašnjenje nove teme, ili dodatni izazov ako ti
                      školski ritam nije dovoljan, ovdje ćeš ga pronaći.
                    </p>
                  </div>
                </div>
              </div>

              <div className="circle-solid">
                <img
                  src={`${s3_url}/homepage/lumenko.webp`}
                  alt="Lumenko"
                  loading="lazy"
                />
              </div>
            </div>
          </Container>
        </section>

        <section className="lessons-pill">
          <Container>
            <div className="pill gradient simple-rounded">
              <Row className="align-items-center g-4">
                <Col md={4} className="text-center">
                  <div className="pill-photo-wrap">
                    <img
                      src={`${s3_url}/poduke/4.webp`}
                      alt="Bilješke i učenje"
                      className="pill-photo"
                      loading="lazy"
                    />
                  </div>
                </Col>
                <Col md={8}>
                  <p className="my-5">
                    Posebna pažnja posvećena je tome da se znanje ne gomila samo
                    za testove, već da učenici zaista razumiju što uče i mogu to
                    primijeniti. Takav pristup gradi sigurnost i samostalnost, a
                    uz to učenje postaje manje stresno i više smisleno.
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
        </section>

        <section className="lessons-online-longer">
          <Container>
            <h1 className="title-shadow text-center red-title upper mt-3 mb-5">
              ONLINE PODUKE KOJE TRAJU DUŽE I DAJU VIŠE
            </h1>
            <p className="copy text-center my-5">
              Ono što je sjajno kod naših online poduka jest da sami birate
              vrijeme kada ćete pohađati poduke! Osim što u kalendar sami
              upisujete termin pohađanja poduka koji vam odgovara i to u svako
              doba dana i svakim danom, uključujući i vikende, online poduke u
              Lumenu traju 60 minuta! Drugim riječima, nudimo vam 15 minuta više
              od uobičajenog trajanja poduka! Poduke se provode putem
              videopoziva, u realnom vremenu, tako da ćeš imati mogućnost
              razgovarati s nastavnikom i postavljati pitanja.
            </p>
          </Container>

          <div
            className="wide-strip"
            style={{ backgroundImage: `url(${s3_url}/poduke/7.webp)` }}
            role="img"
            aria-label="Detalj s poduka"
          />
        </section>

        <section className="lessons-teachers-info">
          <Container>
            <Row className="g-5 align-items-center">
              <Col md={4} className="text-center">
                <img
                  src={`${s3_url}/poduke/6.webp`}
                  alt="Nastavnik"
                  className="circle-photo-large"
                  loading="lazy"
                />
              </Col>
              <Col md={8}>
                <p className="teachers-copy">
                  Poduke vode naši dugogodišnji suradnici s višegodišnjim
                  iskustvom rada u školi, kao i vođenju poduke za ispite državne
                  mature i izvođenje poduka. Upoznati naše nastavnike možeš na
                  izbornoj traci, gumb nastavnici.
                </p>
              </Col>
            </Row>

            <div className="pill gradient simple-rounded mt-5">
              <p className="mb-0 text-center pill2-copy">
                Želimo održati kvalitetu našeg rada i u virtualnom okruženju pa
                će se poduke održavati individualno kako bismo se u potpunosti
                posvetili savladavanju/usavršavanju gradiva pojedinca. Ukoliko
                postoji više učenika iz istog razreda koji žele poduke iz istog
                dijela gradiva, Lumen vam daje i tu mogućnost, uz naznaku
                prilikom prijave i dodatne pogodnosti u vidu popusta na
                količinu!
              </p>
            </div>
          </Container>
        </section>

        <section className="lessons-apply-cta">
          <Container>
            <h1 className="title-shadow text-center red-title apply-title">
              Kako se prijaviti na poduke na Lumen@home?
            </h1>

            <Row className="g-4 align-items-start justify-content-center">
              <Col md={4} className="text-center apply-mascot-col">
                <img
                  src={`${s3_url}/homepage/lumenko.webp`}
                  alt="Lumenko"
                  className="apply-lumenko"
                  loading="lazy"
                />
              </Col>
              <Col md={8} className="apply-copy-col">
                <p className="apply-copy">
                  Prijava je brza i jednostavna! Sve što trebaš napraviti jest
                  kliknuti na gumb „Prijavi se“ i ispuniti prijavnicu za poduke.
                </p>
                <p className="apply-copy">
                  Ako ti zatreba dodatna pomoć ili imaš pitanja, slobodno nam se
                  javi na info@lumenpoduke.com ili na broj 098 257 119 – rado
                  ćemo ti pomoći!
                </p>

                <LumenButton to="/poduke/rezervacija" className="post-hero-cta">
                  PRIJAVI SE
                </LumenButton>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <NewFooter />
    </>
  );
};

export default NewLessonsPage;
